import { render, staticRenderFns } from "./UploadOss.vue?vue&type=template&id=f663e472&scoped=true"
import script from "./UploadOss.vue?vue&type=script&lang=js"
export * from "./UploadOss.vue?vue&type=script&lang=js"
import style0 from "./UploadOss.vue?vue&type=style&index=0&id=f663e472&prod&lang=scss&scoped=true"
import style1 from "./UploadOss.vue?vue&type=style&index=1&id=f663e472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f663e472",
  null
  
)

export default component.exports